<template>
  <el-dialog width="600px" title="批量移动和恢复礼包" v-model="isvisible">
    <el-form
      ref="goodsFormRef"
      :model="goodsForm"
      :rules="rules"
      label-width="120px"
    >
      <div v-if="flag==='goodsRemove'">
        您确定要把礼包移动到回收站吗？
      </div>
      <div v-if="flag==='goodsRecover'">
        您确定要把礼包恢复到礼包库吗？
      </div>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
        <el-button type="danger" @click="doBatchSaveGoodsGiftRemoveRecover" :loading="loading" >{{
          loading ? "提交中 ..." : "确认"
        }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>
  <script setup>
import { ref, defineExpose, defineEmits } from "vue";
import { ElMessage } from "element-plus";
import { batchSaveGoodsGiftRemoveRecover } from "@/api/goodsGiftPack";

let timer;

const loading = ref(false);

const emit = defineEmits(["click"]); // 声明触发事件 change

const isvisible = ref(false);
const changeVisible = (v) => {
  isvisible.value = v;
};

const goodsFormRef = ref();
const goodsForm = ref({
  goodsid: "",
  status: ""
});

const flag = ref()

const goodsGiftRemoveRecoverMethod = (obj) => {
  console.log('----obj-----',obj)
  goodsForm.value = {
    goodsid: obj.goodsid,
    status: obj.status
  };
  flag.value = obj.flag
};

defineExpose({ changeVisible, goodsGiftRemoveRecoverMethod });

const doBatchSaveGoodsGiftRemoveRecover = () => {
  goodsFormRef.value.validate((valid) => {
    if (!valid) {
      // ElMessage("请先完善表单数据填写！");
      return;
    }

    let goods = [];
    let goodsids = goodsForm.value.goodsid;

    for (let i = 0; i < goodsids.length; i++) {
      goods.push({
        goodsid: goodsids[i],
        status: goodsForm.value.status
      });
    }
    // console.log("orders---", orders);
    // console.log("goodsForm.value---", goodsForm.value);

    batchSaveGoodsGiftRemoveRecover(goods).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          closeDialog()
          emit('click')
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

const closeDialog = () => {
  isvisible.value = false;
  goodsFormRef.value.resetFields();
  clearTimeout(timer);
};

//表单验证规则
const rules = ref({
  salestatus: [
    {
      required: true,
      message: "请选择售后状态",
      trigger: "change",
    }
  ]
});
</script>
  <style scoped>
.el-dialog {
  text-align: left;
}
.el-dialog__body {
  padding-top: 15px;
}
</style>